export default "__VITE_ASSET__D7dT5RWL__"